import { baseApi } from "api/BaseApi";
import { PaginatedResponse } from "api/common/types/response.types";

import {
  AllArchivedOrRelatedTdsResponse,
  TechnicalDecision,
} from "./technicalDecisions.types";

const TECHNICAL_DECISIONS_BASE_URL = "technical-decision";

const technicalDecisionsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listTds: build.query<PaginatedResponse<TechnicalDecision>, void>({
      query: () => `${TECHNICAL_DECISIONS_BASE_URL}/`,
    }),

    getAllTdsById: build.query<TechnicalDecision[], number | string>({
      query: (id) => ({
        url: `${TECHNICAL_DECISIONS_BASE_URL}/get_all_tds_by_id/`,
        params: {
          profile: id,
        },
      }),
    }),

    getAllArchivedOrRelatedTdsById: build.query<
      AllArchivedOrRelatedTdsResponse,
      string
    >({
      query: (id) => ({
        url: `${TECHNICAL_DECISIONS_BASE_URL}/get_all_archived_or_related_tds_by_id/`,
        params: {
          profile: id,
        },
      }),
    }),
  }),

  overrideExisting: false,
});

export const {
  useListTdsQuery,
  useGetAllTdsByIdQuery,
  useLazyGetAllTdsByIdQuery,
  useGetAllArchivedOrRelatedTdsByIdQuery,
} = technicalDecisionsApi;
